import styled from 'styled-components';
import { ReactComponent as DefaultLogoImg } from '@assets/logo/mot-logo.svg';

export const Img = styled.img`
  height: 100%;
  padding: 14px 0;
  vertical-align: top;
  transition: 0.2s;

  :hover {
    transform: scale(1.05);
  }
`;

export const DefaultImage = styled(DefaultLogoImg)`
  max-width: 64px;
  height: 100%;
  transition: 0.2s;

  .logo-meu-iot-text {
    fill: ${({ theme }) => theme.colors.text};
  }

  :hover {
    transform: scale(1.05);
  }
`;
